export const downloadURI = (uri: any) => {
  var link = document.createElement('a');
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const flashProductsFilterSerializer = (_filters: any) => {
  const filters = Object.assign({}, _filters);

  filters.brandId = filters.brandId?.map((e: any) => e.value);

  if (filters.categoryId && typeof filters.categoryId === 'string') {
    filters.categoryId = filters.categoryId.split(',');
  }

  if (filters.brandId && typeof filters.brandId === 'string') {
    filters.brandId = filters.brandId.split(',');
  }

  return filters;
};
